export const themedControlClassName = 'theme-control border transition-colors';

export const themedActiveControlClassName = 'theme-control-active border transition-colors';

export const themedGhostControlClassName = 'theme-ghost-control transition-colors';

export const themedFormControlClassName = 'theme-form-control';

export const themedResultPanelClassName = 'theme-result-panel';

export function joinClassNames(...classNames: Array<string | false | null | undefined>) {
  return classNames.filter(Boolean).join(' ');
}
